<pg-home>
  <pg-home-section1 class="home-section" id="home"/>
  <pg-home-section2 class="home-section" id="about"/>
  <pg-home-section4 class="home-section" id="solutions" route={props.route}/>
  <pg-home-section5 class="home-section" id="social"/>

  <div id="home-sections-bullets">
  </div>

  <script>
    import './pg-home.scss'

    import PgHomeSection1 from './pg-home-sections/pg-home-section-1.riot'
    import PgHomeSection2 from './pg-home-sections/pg-home-section-2.riot'
    import PgHomeSection4 from './pg-home-sections/pg-home-section-4.riot'
    import PgHomeSection5 from './pg-home-sections/pg-home-section-5.riot'

    import * as utils from '../helpers/utils'

    export default {
      components: {
        PgHomeSection1,
        PgHomeSection2,
        PgHomeSection4,
        PgHomeSection5,
      },
      onMounted () {
        this.sections = []
        this.setBullets()

        document.addEventListener('section-change', this.setActiveBullet)
      },
      onBeforeUnmount() {
        document.removeEventListener('section-change', this.setActiveBullet)
      },
      onUpdated(props){
        if(props.route.query.section) {
          setTimeout(()=>{
            this.$("#" + props.route.query.section).scrollIntoView(true)
          },0)
        }
      },
      setBullets() {
        const sectionsEl = this.$$('.home-section > section')
        const bulletsContainer = this.$('#home-sections-bullets')

        sectionsEl.forEach(el => {
          this.sections.push(el)
          const bulletTag = document.createElement('a')
          bulletTag.dataset.target = el.id
          bulletTag.onclick = () => {this.goToSection(el)}
          bulletsContainer.appendChild(bulletTag)
        })
      },
      setActiveBullet(e) {
        const currSectionId = e.detail.newSection.id
        const bulletsEl = this.$$('#home-sections-bullets a')

        this.currSectionEl = e.detail.newSection

        bulletsEl.forEach(el => {
          if (el.dataset.target != currSectionId) {
            el.classList.remove('active')
          } else {
            el.classList.add('active')
          }
        })
      },
      goToSection(sectionEl) {
        const sectionYOffset = sectionEl.offsetTop
        window.scrollTo(0, sectionYOffset)
      },
    }
  </script>
</pg-home>
